export default "__VITE_ASSET__K1IEMFK1__"